export default __webpack_public_path__ + "static/media/arcade_pacman_sprites.fa536a98.png";